declare type resolutions = 'small' | 'medium' | 'large' | 'xlarge';

export const RESOLUTIONS: { [K in resolutions]: number } = {
  small: 767,
  medium: 992,
  large: 1200,
  xlarge: 1400
};

export const SX_STYLES = {
  maxWidth: {
    xl: '1100px',
    lg: '1100px',
    md: '991px',
    sm: '766px'
  }
};

export const ADVISOR_AVAILABILITY = {
  callAvailability: {
    takingCalls: 0,
    offline: 6,
    arrangeCalls: 5,
    offlineWithArrangeCalls: 7
  },
  chatAvailability: {
    takingChat: 2,
    offline: 1,
    arrangeChats: 4
  }
};

export const CALL_AVAILABILITY_PROP = {
  [ADVISOR_AVAILABILITY.callAvailability.takingCalls]: 'available',
  [ADVISOR_AVAILABILITY.callAvailability.offline]: 'send_mail',
  [ADVISOR_AVAILABILITY.callAvailability.arrangeCalls]: 'arrange',
  [ADVISOR_AVAILABILITY.callAvailability.offlineWithArrangeCalls]:
    'request_appointment'
};

export const CHAT_AVAILABILITY_PROP = {
  [ADVISOR_AVAILABILITY.chatAvailability.takingChat]: 'available',
  [ADVISOR_AVAILABILITY.chatAvailability.offline]: 'offline',
  [ADVISOR_AVAILABILITY.chatAvailability.arrangeChats]: 'arrange'
};

export const CALL_AVAILABILITY_TYPE = {
  CALL_NOW: 0,
  CALL_NOW_ALERT: 1,
  SEND_MAIL_BUSY: 2,
  ARRANGE_APPOINTMENTS_BUSY: 3,
  ARRANGE_CALL_BUSY: 4,
  ARRANGE_CALL_AWAY: 5,
  SEND_MAIL_AWAY: 6,
  ARRANGE_APPOINTMENTS_AWAY: 7
};

export const CHAT_AVAILABILITY_TYPE = {
  UNKNOWN: 0,
  CHAT_LATER: 1,
  CHAT_NOW: 2,
  BUSY: 3,
  ARRANGE_CHAT: 4
};

export const EVENT_ACTION_TYPES = {
  viewed: 0,
  clicked: 1
};

export const CALL_FLOW_SOURCE = {
  keenCarouselBMButton: 68,
  WebHomePageCall: 41
};

export const CHAT_FLOW_SOURCE = {
  keenCarouselBMButton: 119,
  WebHomePageChat: 10
};

export const LISTINGS_CALL_FLOW = {
  WebHomePageADPLinkCallButton: 94
};

export const LISTINGS_CHAT_FLOW = {
  WebHomePageADPLinkChatButton: 145
};

export const USER_TYPE = {
  advisor: 4,
  consumer: 3
};

export const PAGE_ID = {
  homePage: 41
};

export const COOKIES = {
  SessionId: 'SessionId',
  keenUid: 'KeenUid',
  siftSessionId: 'SiftSessionId'
};

export const SCREEN = {
  homePage: 'homepage'
};
